import React from "react";
import AuthorImage from "blog-md/authors/mch_256_a.png";
import { Link } from "gatsby";

export interface MagentoConsultingBannerProps {
  onClose: () => void;
}

const MagentoConsultingBanner = ({ onClose }: MagentoConsultingBannerProps) => {
  return (
    <div className="my-5 px-5 py-10 md:px-10
      border-t-2 border-t-lucid-700 border-r-2 border-r-lucid-900
      shadow-md
      bg-gradient-to-l from-lucid-800 to-transparent
      rounded-lg flex flex-col gap-5 md:flex-row md:gap-10 items-center justify-center"
    >
      <div className="flex flex-row items-center justify-center">
        <img
          src={AuthorImage}
          alt="Consulting avatar"
          width="128"
          height="128"
        />
      </div>
      <div className="text-center">
        <p className="text-lg font-bold mb-2">
          Do you need assistance with your Magento 2 store?
        </p>
        <div className="flex flex-col md:flex-row gap-2 items-center justify-center"
             data-aos="fade-up"
             data-aos-delay="250"
        >
          <Link to="/inquiry"
                className="btn text-white bg-accent-500 hover:bg-accent-600 w-full shadow-sm group font-bold"
          >
            Yes, I need help
          </Link>
          <button
            className="btn text-lucid-300 bg-lucid-900 hover:bg-lucid-600 border-lucid-600 w-full shadow-sm"
            onClick={e => {
              onClose();
              e.preventDefault();
            }}
          >
            I'm fine
          </button>
        </div>
      </div>
    </div>
  );
};

export default MagentoConsultingBanner;
